export default "__VITE_ASSET__BhMLYJTA__"